import Button from "@material-ui/core/Button";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataFromTable } from "../../services/assortment_management/actions";
import { BackModal } from "../BackModal";

export default function TableContent(props) {
  const [tableContent, setTableContent] = useState([]);
  const params = useParams();
  let navigate = useNavigate();

  useEffect(() => {
    fetchDataFromTable(params.table).then((res) => {
      setTableContent(res);
    });
  }, []);

  let filtered_table = props.dataModel?.filter(
    (table) => table.name == params.table
  )[0];
  let filtered_fields = filtered_table?.description.fields;

  return (
    <div style={{ display: "relative" }}>
      <BackModal />
      <Button
        onClick={() => navigate(`/assortment-management/${params.table}/new`)}
        style={{ color: "var(--primary-color" }}
      >
        {"Voeg toe +"}
      </Button>

      {tableContent?.map((entry) => (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginBottom: "20px",
              justifyContent: "space-evenly",
            }}
          >
            {Object.keys(entry).map((option) => {
              let datamodel_field_entry = filtered_fields?.filter(
                (field) => field.name == option
              )[0];
              let order = datamodel_field_entry?.order;
              return (
                datamodel_field_entry?.list && (
                  <p style={{ margin: "5px", order: order, fontSize: "14px " }}>
                    <span style={{ fontWeight: "bold" }}>{option}: </span>
                    {String(entry[option])}
                  </p>
                )
              );
            })}
            {/* <span style={{ marginRight: "5px" }}>{entry.naam}</span>
						<span>{entry.code}</span> */}
          </div>
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            <span
              onClick={() =>
                navigate(`/assortment-management/${params.table}/${entry.code}`)
              }
            >
              {"Wijzig"}
            </span>
            <span onClick={() => alert("Delete call is nog niet gemaakt")}>
              {"Verwijder"}
            </span>
          </div>
          <hr />
        </>
      ))}
    </div>
  );
}
